import HelperService from "../../services/helper-service";
import {AppRoutes, AttachmentTypes, BuildingOwnershipTypes, BuildingStatTypes} from "../../utils/constants";
import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import BuildingStatWidgetContent from "./building-stat-widget-content";
import FormatService from "../../services/format-service";
import BuildingStatYieldWidget from "./building-stat-yield-widget";
import BuildingStatShareWidget from "./building-stat-share-widget";

export default function BuildingPortfolioRow({ building, ...props}) {
  const [cover, setCover] = useState();

  useEffect(()=>{
    if (building){
      let ci = HelperService.getObjByKey(building.attachments, 'attachment_type_id', AttachmentTypes.cover.val);
      setCover(ci ? ci : null);
    } else {
      setCover(null);
    }
  }, [building]);


  return (
    <>

      <div className="col-12 mb-1">
        <div className="card p-relative overflow-hidden">
          <div className="card-body p-0">
            <div className="row g-0">
              {cover && <div className="col-sm-6 col-lg-2">
                <div className="building-portfolio-row-card">
                  <Link to={AppRoutes.buildingsPortfolio.path+'/'+building.id}>
                    <img src={cover?.url} alt="" style={{maxWidth: '100%'}} />
                  </Link>
                </div>
              </div>}
              <div className="col-sm-6 col-lg-2">
                <div className="building-portfolio-row-card">
                  <Link to={AppRoutes.buildingsPortfolio.path+'/'+building.id}>
                    <h3>{building.title}</h3>
                    <span className={`badge badge-lg bg-${HelperService.getObjByKey(Object.values(BuildingOwnershipTypes), 'val', building.ownership_type).color}`}>{HelperService.getObjByKey(Object.values(BuildingOwnershipTypes), 'val', building.ownership_type).title}</span>
                  </Link>
                </div>
              </div>
              <BuildingStatShareWidget shares={building?.shares} containerClass={"col-sm-6 col-lg-2"} widgetClass={'building-portfolio-row-card'} />
              <BuildingStatWidgetContent stat={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.capacity.val)} buildingId={building.id} containerClass={"col-sm-6 col-lg-2"} widgetClass={'building-portfolio-row-card'}
                                         second={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.capacityReserved.val)}
                                         third={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.capacityAccepted.val)}
                                         fourth={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.capacityFree.val)}
              />
              {/*<BuildingStatYieldWidget containerClass={'col-sm-6 col-lg-2 building-portfolio-row-card'} stats={building.stats} buildingId={building.id} />*/}
              <BuildingStatWidgetContent stat={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.parkingPlaces.val)} buildingId={building.id} containerClass={"col-sm-6 col-lg-2 bg-success text-white"} widgetClass={'building-portfolio-row-card border-0'} />
              <BuildingStatWidgetContent stat={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.repairFund.val)} buildingId={building.id} containerClass={"col-sm-6 col-lg-2 bg-indigo text-white"} widgetClass={'building-portfolio-row-card border-0'} />
              <BuildingStatWidgetContent stat={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.lentArea.val)} buildingId={building.id} containerClass={"col-sm-6 col-lg-2"} widgetClass={'building-portfolio-row-card'} />
              <BuildingStatWidgetContent stat={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.rent.val)} buildingId={building.id} containerClass={"col-sm-6 col-lg-4"} widgetClass={'building-portfolio-row-card'} />
              <BuildingStatWidgetContent stat={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.profit.val)} buildingId={building.id} containerClass={"col-sm-6 col-lg-4"} widgetClass={'building-portfolio-row-card'} />
              <BuildingStatWidgetContent stat={HelperService.getObjByKey(Object.values(building.stats), 'type_sync_id', BuildingStatTypes.buildingValue.val)} buildingId={building.id} containerClass={"col-sm-6 col-lg-2"} widgetClass={'building-portfolio-row-card'} />
            </div>
            <div className="clearfix"></div>

          </div>
        </div>
      </div>

    </>
  );
}
